<template>
    <Dialog v-model:open="opened">
        <DialogTrigger><slot /></DialogTrigger>
        <DialogContent>
            <DialogHeader class="items-center">
                <template #icon>
                    <MicrosoftLogo />
                </template>
                <DialogTitle>{{
                    $t("integrations.microsoft.modal.title")
                }}</DialogTitle>
            </DialogHeader>

            <div class="px-6 py-4">
                <MicrosoftIntegration :integration="integration" />
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 rounded-md border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:ring-z-orange-500 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm inline-flex w-full justify-center border focus:ring-2 focus:ring-offset-2 focus:outline-none"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog-v2";
import MicrosoftIntegration from "./MicrosoftIntegration.vue";
import MicrosoftLogo from "../logos/simple/Microsoft.svg";

defineProps<{
    integration?: any;
}>();
const opened = ref(false);

const closeModal = () => {
    opened.value = false;
};
</script>
